// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"a8a59128","85":"97a5e7a1","286":"a83ef539","426":"a78d027b","448":"50420a31","787":"962fb81d","895":"ce9c4374"}[chunkId] + ".chunk.js";
};